import Component from "../abstracts/Component";
import { doAjax } from '../utils/ajaxUtil';
import _ from "lodash";
import slick from "slick-carousel";

export default class InfoBoxCarouselComponent extends Component {
  get SELECTORS() {
    return {
      main: '.carousel-wrapper',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
      openReplaceFidelityButton: '.info-box__item__fidelity',
      replaceFidelityPopover: '#replace-fidelity',
      replaceFidelitySubmit: '#replace-fidelity-submit',
      replaceFidelityWrapper: '.info-box__replace-fidelity__wrapper',
      replaceFidelitySuccess: '.info-box__replace-fidelity__success',
      replaceFidelityError: '.info-box__replace-fidelity__error',
      replaceFidelitySuccessDescription: '#replace-fidelity-success'
    };
  }

  get CLASSES() {
    return {
      hidden: 'hidden',
      show: 'show'
    }
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.whatchRes = [];
    var _this = this;

    this.openReplaceFidelityButton = $(this.SELECTORS.openReplaceFidelityButton);
    this.replaceFidelityPopover = $(this.SELECTORS.replaceFidelityPopover);
    this.replaceFidelitySubmit = $(this.SELECTORS.replaceFidelitySubmit, '.vex');
    this.replaceFidelityWrapper = $(this.SELECTORS.replaceFidelityWrapper, '.vex');
    this.replaceFidelitySuccess = $(this.SELECTORS.replaceFidelitySuccess, '.vex');
    this.replaceFidelityError = $(this.SELECTORS.replaceFidelityError, '.vex');
    this.replaceFidelitySuccessDescription = $(this.SELECTORS.replaceFidelitySuccessDescription, '.vex');

    $(window).resize(_.debounce(function(){
        var $windowWidth = $(window).width();
        if ($windowWidth < 1024 && $('.info-box__wrapper.slider-on').not('.slick-initialized').length) {
            _this.initCarousel();   
        }
    }, 500));
  }

  bindEvents() {
    let ctx = this;
    let html = $('.info-box__replace-fidelity').html();
    this.openReplaceFidelityButton.on('click', () => {
      ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
        unsafeContent: html,
        modalClass: 'info-box__replace-fidelity'
      });
    });

    ctx.$on(ctx.$customEvents.MODAL_EVENTS.afterOpen, () => {
      $('#replace-fidelity-submit', '.vex').on('click', (event) => {
        const submitBtn = event.target;
        const contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
        const url = `${contextPath}/my-account/fidelity?change-fidelity-card`;

        if (!submitBtn) return;

        let btnTextNode = null;
        let btnText = "";
        submitBtn.disabled = true

        submitBtn.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== "") {
              btnTextNode = node;
              btnText = node.nodeValue.trim();
          }
        });

        if (btnTextNode) btnTextNode.nodeValue = "";
        submitBtn.querySelectorAll(".loading-dot").forEach(dot => dot.remove());

        for (let i = 0; i < 3; i++) {
            let dot = document.createElement("span");
            dot.classList.add("loading-dot");
            submitBtn.appendChild(dot);
        }
    
        submitBtn.classList.add("button--loading");

        doAjax({
          type: 'POST',
          url: url,
          success: (data) => {
            if (data.error == 'no') {
              let text = $(this.SELECTORS.replaceFidelitySuccessDescription, '.vex').text();
              text = text.replace('{0}', data.oldFidelityCardNumber);
              text = text.replace('{1}', data.newFidelityCardNumber);

              $(this.SELECTORS.replaceFidelitySuccessDescription, '.vex').text(text);
              $(this.SELECTORS.replaceFidelityWrapper, '.vex').addClass(this.CLASSES.hidden);
              $(this.SELECTORS.replaceFidelityError, '.vex').addClass(this.CLASSES.hidden);
              $(this.SELECTORS.replaceFidelityError, '.vex').removeClass(this.CLASSES.show);
              $(this.SELECTORS.replaceFidelitySuccess, '.vex').removeClass(this.CLASSES.hidden);
              $(this.SELECTORS.replaceFidelitySuccess, '.vex').addClass(this.CLASSES.show);
            } else {
              console.error('Error when replacing fidelity card', {data});
              $(this.SELECTORS.replaceFidelityWrapper, '.vex').addClass(this.CLASSES.hidden);
              $(this.SELECTORS.replaceFidelityError, '.vex').removeClass(this.CLASSES.hidden);
              $(this.SELECTORS.replaceFidelityError, '.vex').addClass(this.CLASSES.show);
              $(this.SELECTORS.replaceFidelitySuccess, '.vex').removeClass(this.CLASSES.show);
              $(this.SELECTORS.replaceFidelitySuccess, '.vex').addClass(this.CLASSES.hidden);
            }
          },
          error: (data) => {
            console.error('Error when replacing fidelity card', {data});
            $(this.SELECTORS.replaceFidelityWrapper, '.vex').addClass(this.CLASSES.hidden);
            $(this.SELECTORS.replaceFidelityError, '.vex').removeClass(this.CLASSES.hidden);
            $(this.SELECTORS.replaceFidelityError, '.vex').addClass(this.CLASSES.show);
            $(this.SELECTORS.replaceFidelitySuccess, '.vex').removeClass(this.CLASSES.show);
            $(this.SELECTORS.replaceFidelitySuccess, '.vex').addClass(this.CLASSES.hidden);
          },
          finally: (data) => {
            if (!submitBtn || !document.body.contains(submitBtn)) return;
            ubmitBtn.disabled = false
            submitBtn.classList.remove("button--loading");
            submitBtn.querySelectorAll(".loading-dot").forEach(dot => dot.remove());
            
            if (btnTextNode) btnTextNode.nodeValue = btnText;
            else if (btnText) submitBtn.prepend(document.createTextNode(btnText));
          }
        });
      });
    }); 
  }

  initCarousel() {
    var _this = this;
    $('.info-box__wrapper.slider-on').slick({
        slidesToShow: 1,
        mobileFirst: true,
        dots: true,
        infinite: false,
        prevArrow: "<button class='icon-chevron-left'></button>",
        nextArrow: "<button class='icon-chevron-right'></button>",
        responsive: [{
            breakpoint: 1024,
            settings: "unslick"
          }
        ]
    })
  }
  
  render() {
    super.render();
    this.initCarousel();
    this.bindEvents();
  }
}
